/* Reset native mobile drawer scroll position on a fresh open.
   Does not affect the native back and nested navigation behavior. */
(function(){
  'use strict';
  var drawer=document.getElementById('mobile-menu');
  if(!drawer || !window.MutationObserver)return;
  var wasVisible=drawer.getAttribute('aria-hidden')==='false';
  var observer=new MutationObserver(function(){
    var visible=drawer.getAttribute('aria-hidden')==='false';
    if(visible && !wasVisible){
      var inner=drawer.querySelector('.mobile-menu__inner');
      if(inner)inner.scrollTop=0;
      var home=drawer.querySelector('.mobile-menu__panel:not(.is-nested)');
      if(home)home.scrollTop=0;
    }
    var toggle=document.querySelector('.header__mobile-nav-toggle[aria-controls="mobile-menu"]');
    if(toggle){
      var originalLabel=toggle.getAttribute('data-lolly-open-label');
      if(!originalLabel){
        originalLabel=toggle.getAttribute('aria-label')||'Open menu';
        toggle.setAttribute('data-lolly-open-label',originalLabel);
      }
      var closeLabel=(document.documentElement.lang||'').toLowerCase().startsWith('ar')?'إغلاق القائمة':'Close menu';
      toggle.setAttribute('aria-label',visible?closeLabel:originalLabel);
    }
    wasVisible=visible;
  });
  observer.observe(drawer,{attributes:true,attributeFilter:['aria-hidden']});
})();

/* lolly scrim-close: tap outside the mobile drawer to dismiss using Warehouse's
   native menu action. Also honor Escape without altering Shopify integrations. */
(function(){
 'use strict';
 var menu=document.getElementById('mobile-menu');
 var toggle=document.querySelector('.header__mobile-nav-toggle[aria-controls="mobile-menu"]');
 if(!menu||!toggle)return;
 function open(){return menu.getAttribute('aria-hidden')==='false';}
 document.addEventListener('pointerdown',function(e){
   if(!open()||!e.target||e.target.closest('#mobile-menu')||e.target.closest('.header__mobile-nav-toggle'))return;
   var inHeader=!!e.target.closest('.header');
   if(inHeader)return;
   e.preventDefault();
   toggle.click();
 });
 document.addEventListener('keydown',function(e){
   if(e.key==='Escape'&&open()){
     e.preventDefault();
     toggle.click();
     toggle.focus();
   }
 });
})();
